<template>
  <header class="main-header">
    <!-- Logo -->
    <a href="#" class="logo" style="position: fixed;">
      <!-- mini logo for sidebar mini 50x50 pixels -->
      <span class="logo-mini"><img style="max-width: 35px;" src="../../../assets/circle-logo.png"></span>
      <!-- logo for regular state and mobile devices -->
      <span class="logo-lg"><img src="../../../assets/circle-logo.png"></span>
    </a>

    <!-- Header Navbar: style can be found in header.less -->
    <nav class="navbar navbar-static-top">
      <div class="container">
        <div class="navbar-header">
          <a @click="Jobpost" class="navbar-brand"><img style="max-width: 35px;" src="../../../assets/circle-logo.png"></a>
          <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar-collapse" aria-expanded="false">
            <i class="fa fa-bars"></i>
          </button>
        </div>
        <!-- Collect the nav  links, forms, and other content for toggling -->
        <div class="navbar-collapse pull-left collapse" id="navbar-collapse" aria-expanded="false" style="height: 1px;">
          <ul class="nav navbar-nav">
              <!-- <li class="active"><a>Post <span class="sr-only">(current)</span></a></li> -->
          <li v-bind:class="{'active': url == 'JobPost' || url == '/JobPost/'}"><a v-on:click="navigation('JobPost')">Post <span class="sr-only">(current)</span></a></li>
            <li v-bind:class="{'active': url == 'Interest' || url == '/Interest/'}"><a v-on:click="navigation('Interest')">Interest</a></li>

            <li v-bind:class="{'active': url == 'ScheduleAvailability' || url == '/ScheduleAvailability/:id'}"><a v-on:click="navigation('ScheduleAvailability')">Availability</a></li>
            <li v-bind:class="{'active': url == 'Schedule' || url == '/Schedule/'}"><a v-on:click="navigation('Schedule')">Schedule</a></li>
            <li v-bind:class="{'active': url == 'Feedback' || url == '/Feedback'}"><a v-on:click="navigation('Feedback')">Feedback</a></li>
          </ul>
        </div>
        <!-- /.navbar-collapse -->
        <!-- Navbar Right Menu -->
        <div class="navbar-custom-menu">
        <ul class="nav navbar-nav">
          <li class="dropdown messages-menu">
            <!-- <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <i class="fa fa-question-circle-o fa-lg"></i>
              <span class="label label-success">{{ unreadMessagesCount }}</span>
            </a> -->
            <!-- <ul class="dropdown-menu">
              <li class="header">You have {{ unreadMessagesCount }} messages</li>
              <li>
                <ul class="menu">
                  <li>
                    <a href="#">
                      <div class="pull-left">
                        <img src="~admin-lte/dist/img/user2-160x160.jpg" class="img-circle" alt="User Image">
                      </div>
                      <h4>
                        Support Team
                        <small><i class="fa fa-clock-o"></i> 5 mins</small>
                      </h4>
                      <p>Why not buy a new awesome theme?</p>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <div class="pull-left">
                        <img src="~admin-lte/dist/img/user3-128x128.jpg" class="img-circle" alt="User Image">
                      </div>
                      <h4>
                        AdminLTE Design Team
                        <small><i class="fa fa-clock-o"></i> 2 hours</small>
                      </h4>
                      <p>Why not buy a new awesome theme?</p>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <div class="pull-left">
                        <img src="~admin-lte/dist/img/user4-128x128.jpg" class="img-circle" alt="User Image">
                      </div>
                      <h4>
                        Developers
                        <small><i class="fa fa-clock-o"></i> Today</small>
                      </h4>
                      <p>Why not buy a new awesome theme?</p>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <div class="pull-left">
                        <img src="~admin-lte/dist/img/user3-128x128.jpg" class="img-circle" alt="User Image">
                      </div>
                      <h4>
                        Sales Department
                        <small><i class="fa fa-clock-o"></i> Yesterday</small>
                      </h4>
                      <p>Why not buy a new awesome theme?</p>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <div class="pull-left">
                        <img src="~admin-lte/dist/img/user4-128x128.jpg" class="img-circle" alt="User Image">
                      </div>
                      <h4>
                        Reviewers
                        <small><i class="fa fa-clock-o"></i> 2 days</small>
                      </h4>
                      <p>Why not buy a new awesome theme?</p>
                    </a>
                  </li>
                </ul>
              </li>
              <li class="footer"><a href="#">See All Messages</a></li>
            </ul> -->
          </li>
          <!-- <span class="lnr lnr-alarm"></span> fa fa-bell-o-->
          <!-- Notifications: style can be found in dropdown.less -->
          <li class="dropdown notifications-menu">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown" @click="getnotification()">
              <img src="../../../assets/img/notify-bell.svg" data-toggle="modal" data-target="#myModal2">
              <span class="label label-danger" v-if="unreadNotificationsCount > 0">{{ unreadNotificationsCount }}</span>
            </a>
            <!-- <ul class="dropdown-menu">
              <li class="header">You have {{ unreadNotificationsCount }} notificationss</li>
              <li>
                <ul class="menu">
                  <li>
                    <a href="#">
                      <i class="fa fa-users text-aqua"></i> 5 new members joined today
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i class="fa fa-warning text-yellow"></i> Very long description here that may not fit into the
                      page and may cause design problems
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i class="fa fa-users text-red"></i> 5 new members joined
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i class="fa fa-shopping-cart text-green"></i> 25 sales made
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i class="fa fa-user text-red"></i> You changed your username
                    </a>
                  </li>
                </ul>
              </li>
              <li class="footer"><a href="#">View all</a></li>
            </ul> -->
          </li>
          <!-- User Account: style can be found in dropdown.less -->
          <li class="dropdown notifications-menu">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <img v-if="userInfo.profile_picture !=null && userInfo.profile_picture !=''" :src="`${userInfo.profile_picture}`" class="user-image" alt="User Image">
              <img v-if="userInfo.profile_picture =='' || userInfo.profile_picture ==null"  src="../../../assets/img/default.png" class="user-image" alt="User Image">
              <i class="fa fa-caret-down ml-5" aria-hidden="true"></i>
              <span class="hidden-xs"></span>
            </a>
            <ul class="dropdown-menu logmenu" style="width: 210px;">
              <li>
                <ul class="menu">
                  <!-- <li>
                    <a href="#">
                      <i class="fa fa-users text-aqua"></i> 5 new members joined today
                    </a>
                  </li> -->
                  <!-- <li>
                    <a href="#">
                      <i class="fa fa-warning text-yellow"></i> Very long description here that may not fit into the
                      page and may cause design problems
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i class="fa fa-users text-red"></i> 5 new members joined
                    </a>
                  </li> -->
                  <!-- <li>
                    <a href="#">
                      <i class="fa fa-shopping-cart text-green"></i> 25 sales made
                    </a>
                  </li> -->
                  <li>
                    <a @click="InterviewerProfile">Manage Profile</a>
                  </li>
                  <li>
                    <a>Account Setting</a>
                  </li>
                  <li>
                    <a @click="logout" href="#">Signout</a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <!-- Control Sidebar Toggle Button -->
          <!-- <li>
            <a href="#" data-toggle="control-sidebar"><i class="fa fa-gears"></i></a>
          </li> -->
        </ul>
      </div>
        <!-- /.navbar-custom-menu -->
      </div>
      <!-- /.container-fluid -->
    </nav>
  </header>
</template>

<script>
import router from '../../../router/index'
// import InterviewerProfile from '../../../pages/Feature/InterviewerPage/InterviewerProfile.vue'

// import axios from 'axios'
// import { BaseURL } from '../../../shared/classes'

export default {
  name: 'TheHeader',
  components: {
    // InterviewerProfile
  },
  data () {
    return {
      unreadMessagesCount: 0,
      unreadNotificationsCount: 0,
      config: {},
      notificationlist: [],
      userInfo: [],
      token: '',
      todaylist: [],
      yesterdaylist: [],
      interval: '',
      url: '',
      showRole: false,
      BaseURL2: 'https://dev.10xfreshers.net/api'
    }
  },
  created () {
    this.url = this.$router.history.current.path
    console.log(this.url)
    this.userInfo = JSON.parse(localStorage.getItem('user__details'))
  },
  mounted () {
    this.$root.$on('navigate', (arg) => {
      console.log(arg)
      this.url = arg
    })
    this.$root.$on('cropUploadSuccess', (arg) => {
      console.log('cropUploadSuccess ===', arg)
      this.userInfo.profile_picture = arg
      localStorage.setItem('user__details', JSON.stringify(this.userInfo))
      // this.url = arg
    })
  },
  methods: {
    navigation (tabs) {
      this.url = tabs
      router.push({ name: tabs })
    },
    logout () {
      localStorage.clear()
      localStorage.setItem('setPassword', JSON.stringify(false))
      router.push({ name: 'LoginPage' })
      // const id = this.userInfo._id
      // clearInterval(this.interval)
      // this.config = {
      //   headers: {
      //     'content-type': 'application/json',
      //     Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
      //   }
      // }
      // axios.get(BaseURL + '/logout/' + id, this.config).then(response => {
      //   localStorage.clear()
      //   localStorage.setItem('setPassword', JSON.stringify(false))
      //   router.push({ name: 'Login' })
      // }).catch(e => {
      // })
    },
    InterviewerProfile () {
      router.push({ name: 'InterviewerProfile' })
    },
    Jobpost () {
      router.push({ name: 'JobPost' })
    },
    profile () {
      router.push({ name: 'Profile' })
    },
    dashboard () {
      router.push({ name: 'Dashboard' })
    },
    settings () {
      router.push({ name: 'Settings' })
    }
  }
}
</script>
<style scoped>
.skin-blue .main-header .navbar .nav>li>a {
    color: #5bad2b;
    background-color: transparent;
}
.skin-blue .main-header .navbar {
  background-color: #32373C;
  opacity: 1;
  border-bottom: 0.5px solid #32373C;
  color:black;
}
.sidebar-toggle:hover {
    background-color: #f1f1f1 !important;
}
.sidebar-toggle {
  color:black !important;
}
.skin-blue .main-header .navbar .nav>li>a:hover, .skin-blue .main-header .navbar .nav>li>a:active {
  background: transparent;
  color: #5bad2b;
}
.skin-blue .main-header .navbar .nav>li>a {
    color: #fff;
}
.skin-blue .main-header .logo {
    background-color: #2D2D2D !important;
    color: #fff;
    border-bottom: 0 solid transparent;
    /* margin-bottom: 4px; */
}
.skin-blue .main-header li.user-header {
    background-color: #5bad2b;
}
.user-image {
  width: 30px !important;
  height: 30px !important;
  border-radius: 50%;
  margin-top: -5px !important;
}
/* start popup */
.modal.left .modal-dialog,
.modal.right .modal-dialog {
  position: fixed;
  margin: auto;
  width: 320px;
  height: 100%;
  -webkit-transform: translate3d(0%, 0, 0);
      -ms-transform: translate3d(0%, 0, 0);
        -o-transform: translate3d(0%, 0, 0);
          transform: translate3d(0%, 0, 0);
}

.modal.left .modal-content,
.modal.right .modal-content {
  height: 100%;
  overflow-y: auto;
}

.modal.left .modal-body,
.modal.right .modal-body {
  padding: 15px 15px 80px;
}

/*Left*/
.modal.left.fade .modal-dialog{
  left: -320px;
  -webkit-transition: opacity 0.3s linear, left 0.3s ease-out;
      -moz-transition: opacity 0.3s linear, left 0.3s ease-out;
        -o-transition: opacity 0.3s linear, left 0.3s ease-out;
          transition: opacity 0.3s linear, left 0.3s ease-out;
}
.modal.left.fade.in .modal-dialog{
  left: 0;
}
/*Right*/
.modal.right.fade .modal-dialog {
  right: -320px;
  -webkit-transition: opacity 0.3s linear, right 0.3s ease-out;
      -moz-transition: opacity 0.3s linear, right 0.3s ease-out;
        -o-transition: opacity 0.3s linear, right 0.3s ease-out;
          transition: opacity 0.3s linear, right 0.3s ease-out;
}
.modal.right.fade.in .modal-dialog {
  right: 0;
}
/* ----- MODAL STYLE ----- */
.modal-content {
  border-radius: 0;
  border: none;
}

.modal-header {
  border-bottom-color: #EEEEEE;
  background-color: #FAFAFA;
}
.modal-dialog {
  width: 307px !important;
  margin: 0px auto !important;
  border-top: 3px solid #60AB2F;
}
.modal-header .close {
  margin-top: 4px;
}
.products-list .product-img img {
    width: 30px;
    height: 30px;
}
.products-list .product-info {
    margin-left: 49px;
}
.modal.right .modal-body {
    padding: 1px 5px 80px 1px;
}
.products-list .product-description {
  display: block;
  color: #999;
  overflow: hidden;
  word-wrap: break-word;
  /* white-space: nowrap; */
  text-overflow: ellipsis;
}
.mins {
  color: #AEAEAE;
  font-weight: 100;
}
.product-description {
  font-size: 12px;
  color: #404040 !important;
}
.date-title {
  background-color: #f4f4f4;
  padding: 4px;
  width: 100%;
}
.logmenu>li .menu>li>a {
    padding: 6px !important;
    color: #444;
}
.logmenu>li .menu>li>a:hover {
    padding: 6px !important;
    color: #444;
    border-left: 3px solid #60AB2F;
}
.main-header {
  position: fixed;
  max-height: 100px;
  z-index: 1030;
  width: 100%;
}
.product-description {
  max-width: 200px;
  word-wrap: break-word !important;
  white-space: inherit !important;
}
.title-name {
  font-weight: 600 !important;
}
.job_title {
  font-weight: 600;
  color: #5bad2b !important;
}
span.job_title {
    color: #5bad2b !important;
}
.v-time-ago__text {
  font-size: 12px !important;
  cursor: pointer;
  color: #AEAEAE;
}
.mins {
  margin-top: -7px !important;
}
.span.v-time-ago__text {
    text-decoration: none;
    line-height: 20px;
    letter-spacing: .1px;
    letter-spacing: 0.09px;
    color: #AEAEAE;
    opacity: 1;
}
i.fa.fa-lg:hover {
    color: #5bad2b !important;
}
.products-list>.item {
  padding: 6px 0;
  border-left: 3px solid #ffffff;
  background: #fff;
  margin-left: 0px;
}
.products-list>.item:hover {
  padding: 6px 0;
  border-left: 3px solid #5bad2b;
  background: #f4f4f4;
  margin-left: 0px;
}
.modal-content {
  border-left: 1px solid #ccc;
}
.product-img {
    text-align: center;
}
.circle-title {
  height: 40px;
  widows: 40px;
  font-size: 12px;
  font-weight: 600;
  color: #B3B3B3;
  margin-left: -8px;
}
.products-list>.item:hover .product-img {
  background-color: #FFFFFF;
}
.product-img {
  height: 35px;
  width: 35px;
  background-color: #F1F1F1;
  border-radius: 25px;
  padding-top: 7px;
  margin-left: 7px;
}
.navbar-brand {
  padding: 9px 15px !important;
}
</style>
